import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { kebabCase } from 'lodash';
import { Observable, concatMap, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CLO010 } from '../interface/clo010';
import { CLO014 } from '../interface/clo014';
import { CLO017 } from '../interface/clo017';
import { CLO024 } from '../interface/clo024';
import { CLO027 } from '../interface/clo027';
import { CLO029 } from '../interface/clo029';
import { CLO040 } from '../interface/clo040';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class PACEDService {

  constructor(private httpClient: HttpClient, private auth: AuthService) {


  }


  /**
   *
   * 參與社團
   *
   */
  CLO010() {
    return this.auth.stNo$.pipe(
      concatMap(stno =>
        this.httpClient.post<CLO010[]>(environment.apiUrl + `CLO010/${stno}`, undefined)
      ));
  }

  /**
* 社會服務活動  09-PurposeLearning_3
*/
  CLO014() {
    return this.auth.stNo$.pipe(
      concatMap(stno =>
        this.httpClient.post<CLO014[]>(environment.apiUrl + `CLO014/${stno}`, undefined)
      ));
  }

  /**
* 01 設計思考活動  09-PurposeLearning_1
*
* 02 問題解決松競賽或活動  09-PurposeLearning_2

  code:04  數位學習活動： 10-ActiveLearning_1

  code:05  自主學習活動   10-ActiveLearning_2


  code:06   國際化相關活動

  Code: 07  產業演講或活動  12-EnterpriseCollaboration_1


  Code: 08  創創類競賽獲獎或活動    12-EnterpriseCollaboration_2

  Code: 09  校內外藝術活動    13-Diversity_1

  Code: 10  跨領域活動    13-Diversity_2

  Code: IS01 學系活動  11-Competence-basedLearning_2_v2
*/
  CLO017(code: '01' | '02' | '04' | '05' | '06' | '07' | '08' | '09' | '10' | 'IS01') {
    return this.auth.stNo$.pipe(
      concatMap(stno =>
        this.httpClient.post<CLO017[]>(environment.apiUrl + `CLO017/${stno}/${code}`, undefined)
      ));
  }


  /**
   *
   *  Code: T   實踐領導書院
   *
   *  Code: M   卓越領導書院
   *
   *  Code: U   菁英領導書院
   *
   */
  CLO017_M(code: 'T' | 'M' | 'U') {
    return this.auth.stNo$.pipe(
      concatMap(stno =>
        this.httpClient.post<CLO017[]>(environment.apiUrl + `CLO017_M/${stno}/${code}`, undefined)
      ));
  }


  CLO024_c(progCode: string) {
    return this.auth.stNo$.pipe(
      concatMap(stno =>
        this.httpClient.post<CLO024[]>(environment.apiUrl + `CLO024_c/${stno}/${progCode}`, undefined)
      ),
      map(a => a[0])
    );
  }

  /**
  *
  *
  * TYPE_CODE='1'  新生課程 09-PurposeLearning_1  ---
  *
  * Code: 2   創創課程  12-EnterpriseCollaboration_2
  *
  * Code:5    自主學習工坊及方案   --------    10-ActiveLearning_2
  *
  * Code: 3   系外選修課程    13-Diversity_2
  *
  *
  * Code:4  EMI課程：   11-Competence-basedLearning_1_
  * */
  CLO027_T(code: '1' | '2' | '3' | '5' | '4'): Observable<CLO027[]> {
    return this.auth.stNo$.pipe(
      concatMap(stno =>
        this.httpClient.post<CLO027[]>(environment.apiUrl + `CLO027_T/${stno}/${code}`, undefined)
      ));
  }

  /**
  * 10-ActiveLearning_2
  *
  * 數位自主課程
  *
  *
  * */
  CLO027_D(): Observable<CLO027[]> {
    return this.auth.stNo$.pipe(
      concatMap(stno =>
        this.httpClient.post<CLO027[]>(environment.apiUrl + `CLO027_D/${stno}`, undefined)
      ));
  }

  /**
 * 09-PurposeLearning_2  ---
 *
 * 專業研究課程
 * */
  CLO027_I(): Observable<CLO027[]> {
    return this.auth.stNo$.pipe(
      concatMap(stno =>
        this.httpClient.post<CLO027[]>(environment.apiUrl + `CLO027_I/${stno}`, undefined)
      ));
  }


  /** 遠距課程   --------    10-ActiveLearning_1 */
  CLO027_L(): Observable<CLO027[]> {
    return this.auth.stNo$.pipe(
      concatMap(stno =>
        this.httpClient.post<CLO027[]>(environment.apiUrl + `CLO027_L/${stno}`, undefined)
      ));
  }


  /**
*
* Code: 016  PsBL課程 09-PurposeLearning_2  ---
*
* Code: 014  USR課程  09-PurposeLearning_3

  Code: 01D  模擬課程   11-Competence-basedLearning_2_

  Code: 012   總整課程  11-Competence-basedLearning_2_

  Code: 011   AI+X課程  11-Competence-basedLearning_2_

  Code: 013   產業鏈結課程  12-EnterpriseCollaboration_1

  Code: 01A   敘事力課程    13-Diversity_1

  code: 01E   國際共授課程  11-Competence-basedLearning_1_v2(1)
* */
  CLO028(code: '016' | '014' | '01D' | '012' | '011' | '013' | '01A' | '01E') {
    return this.auth.stNo$.pipe(
      concatMap(stno =>
        this.httpClient.post<CLO027[]>(environment.apiUrl + `CLO028/${stno}/${code}`, undefined)
      ));
  }


  /**
   *   ---
   *
   * Code: 10905 設計思考微學程   09-PurposeLearning_1
   *
   * Code: 11011 解決問題促進健康微學程   09-PurposeLearning_1
   *
   * Code: 10623 人工智慧學分學程   10-ActiveLearning_1
   *   *
   * Code: 10803  國際影響力學程  11-Competence-basedLearning_1_
   *
   *
   * Code: 10624    創新創業學分學程    12-EnterpriseCollaboration_2
   *
   * Code: 09403  醫學人文學分學程      13-Diversity_1
   *
   * Code: 10620  敘事創作微學程    13-Diversity_1
   *
   * '11013'  社會參與學程
   */
  CLO029(code: '10905' | '11011' | '10623' | '10803' | '10624' | '09403' | '10620' | '11013', stno?: string): Observable<CLO029[]> {
    console.log(stno)
    if (stno)
      return this.httpClient.post<CLO029[]>(environment.apiUrl + `CLO029/${stno}/${code}`, undefined);

    return this.auth.stNo$.pipe(
      concatMap(stno =>
        this.httpClient.post<CLO029[]>(environment.apiUrl + `CLO029/${stno}/${code}`, undefined)
      ));
  }

  /**
   *
   * Code:P   專業學系之學程：  11-Competence-basedLearning_2_
   *
   * Code:I 國際醫療.衛生暨外交學分學程    11-Competence-basedLearning_1_
   *
   * Code:D   產業相關微學程  12-EnterpriseCollaboration_1
   *
   *  Code:C  跨領域學分學程  13-Diversity_2
   */
  CLO030(code: 'I' | 'P' | 'D' | 'C') {
    return this.auth.stNo$.pipe(
      concatMap(stno =>
        this.httpClient.post<CLO029[]>(environment.apiUrl + `CLO030/${stno}/${code}`, undefined)
      ));
  }

  CLO030_2(code: string) {
    return this.auth.stNo$.pipe(
      concatMap(stno =>
        this.httpClient.post<CLO029[]>(environment.apiUrl + `CLO030_2/${stno}/${code}`, undefined)
      ));
  }


  CLO040(progCode: string) {
    return this.auth.stNo$.pipe(
      concatMap(stno =>
        this.httpClient.post<CLO040[]>(environment.apiUrl + `CLO040/${stno}/${progCode}`, undefined)
      ),
      map(a => a[0])
    );
  }

}
